module.exports = require("classnames");


/*****************
 ** WEBPACK FOOTER
 ** external "classnames"
 ** module id = 42
 ** module chunks = 0
 **/